<template>
    <div class="filterbox-wrapper">
        <div id="filterbox" class="select-btn-box">
            <button id="colorButton" @click.prevent="showFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (filtercolor === '' || typeof filtercolor === 'undefined' ? '' : 'active'), classcolor]">
                <span>{{ buttonColor }}</span>
            </button>
            <div v-show="showColor" id="colorFilter" class="select-btn-box">
                <button data-select="color" id="white" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['White'] }}</span>
                </button>
                <button data-select="color" id="blue" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Blue'] }}</span>
                </button>
                <button data-select="color" id="black" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Black'] }}</span>
                </button>
                <button data-select="color" id="pink" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Pink'] }}</span>
                </button>
                <button data-select="color" id="grey" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Grey'] }}</span>
                </button>
                <button data-select="color" id="brown" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Brown'] }}</span>
                </button>
                <button data-select="color" id="red" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Red'] }}</span>
                </button>
                <button data-select="color" id="others" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Others'] }}</span>
                </button>
                <button data-select="color" id="all" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['All'] }}</span>
                </button>
            </div>
            <button id="patternButton" @click.prevent="showFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (filterpattern === '' || typeof filterpattern === 'undefined' ? '' : 'active'), classpattern]">
                <span>{{ buttonPattern }}</span></button>
            <div v-show="showPattern" id="patternFilter" class="select-btn-box">
                <button data-select="pattern" id="chambray" @click.prevent="setFilter" class="select-btn basic-bg">
                    <span>{{ translations['Chambray Look'] }}</span></button>
                <button data-select="pattern" id="checks" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Checks'] }}</span>
                </button>
                <button data-select="pattern" id="dots" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Dots'] }}</span>
                </button>
                <button data-select="pattern" id="heringbone" @click.prevent="setFilter" class="select-btn basic-bg">
                    <span>{{ translations['Heringbone'] }}</span></button>
                <button data-select="pattern" id="plain" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Plain'] }}</span>
                </button>
                <button data-select="pattern" id="stripes" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Stripes'] }}</span>
                </button>
                <button data-select="pattern" id="all" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['All'] }}</span>
                </button>
            </div>
            <button id="priceButton" @click.prevent="showFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (range1.value !== range1.min || range2.value !== range2.max) ? 'active' : '' ]">
                <span>{{ buttonPrice }}</span></button>
            <div v-show="showPrice" id="priceFilter" class="select-btn-box">
                <span class="close" @click.prevent="closePrice">x</span>
                <button data-start="49" data-end="70" @click.prevent="setPriceRange" class="select-btn basic-bg">49 - 70 €</button>
                <button data-start="71" data-end="90" @click.prevent="setPriceRange" class="select-btn basic-bg">71 - 90 €</button>
                <button data-start="91" data-end="100" @click.prevent="setPriceRange" class="select-btn basic-bg">91 - 100 €</button>
                <button data-start="49" data-end="100" @click.prevent="setPriceRange" class="select-btn basic-bg">{{ translations['All'] }}</button>
            </div>
            <button id="weaveButton" @click.prevent="showFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (filterweave === '' || typeof filterweave === 'undefined' ? '' : 'active'), classweave]">
                <span>{{ buttonWeave }}</span>
            </button>
            <div v-show="showWeave" id="weaveFilter" class="select-btn-box">
                <button data-select="weave" id="dobby" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Dobby'] }}</span>
                </button>
                <button data-select="weave" id="fil-a-fil" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Fil-a-Fil'] }}</span>
                </button>
                <button data-select="weave" id="heringbone" @click.prevent="setFilter" class="select-btn basic-bg">
                    <span>{{ translations['Heringbone'] }}</span></button>
                <button data-select="weave" id="chambray" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Chambray'] }}</span>
                </button>
                <button data-select="weave" id="lacoste" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Lacoste'] }}</span>
                </button>
                <button data-select="weave" id="poplin" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Poplin'] }}</span>
                </button>
                <button data-select="weave" id="twill" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['Twill'] }}</span>
                </button>
                <button data-select="weave" id="all" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['All'] }}</span>
                </button>
            </div>
            <button id="materialButton" @click.prevent="showFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (filtermaterial === '' || typeof filtermaterial === 'undefined' ? '' : 'active'), classmaterial]">
                <span>{{ buttonMaterial }}</span>
            </button>
            <div v-show="showMaterial" id="materialFilter" class="select-btn-box">
                <button data-select="material" id="100%_cotton" @click.prevent="setFilter" class="select-btn basic-bg">
                    <span>{{ translations['100% Cotton'] }}</span></button>
                <button data-select="material" id="cotton_blend" @click.prevent="setFilter" class="select-btn basic-bg">
                    <span>{{ translations['Cotton Blend'] }}</span></button>
                <button data-select="material" id="all" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['All'] }}</span>
                </button>
            </div>
            <button id="new" @click.prevent="setBoolFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (boolfilter['new'] !== '1' ? '' : 'active')]"><span>{{ buttonNew }}</span>
            </button>
            <button id="topseller" @click.prevent="setBoolFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (boolfilter['topseller'] !== '1' ? '' : 'active')]">
                <span>{{ buttonTopseller }}</span></button>
            <button id="occasionButton" @click.prevent="showFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (filteroccasion === '' || typeof filteroccasion === 'undefined' ? '' : 'active'), classoccasion]">
                <span>{{ buttonOccasion }}</span></button>
            <div v-show="showOccasion" id="occasionFilter" class="select-btn-box">
                <button data-select="occasion" id="all_occasions" @click.prevent="setFilter"
                        class="select-btn basic-bg"><span>{{ translations['All Occassions'] }}</span></button>
                <button data-select="occasion" id="business_festive" @click.prevent="setFilter"
                        class="select-btn basic-bg"><span>{{ translations['Business & Festive'] }}</span></button>
                <button data-select="occasion" id="business_festive_casual" @click.prevent="setFilter"
                        class="select-btn basic-bg"><span>{{ translations['Business & Festive/ Casual'] }}</span>
                </button>
                <button data-select="occasion" id="leisure_festive" @click.prevent="setFilter"
                        class="select-btn basic-bg"><span>{{ translations['Leisure & Festive'] }}</span></button>
                <button data-select="occasion" id="leisure_casual" @click.prevent="setFilter"
                        class="select-btn basic-bg"><span>{{ translations['Leisure/ Casual'] }}</span></button>
                <button data-select="occasion" id="all" @click.prevent="setFilter" class="select-btn basic-bg"><span>{{ translations['All'] }}</span>
                </button>
            </div>
            <button id="nameButton" @click.prevent="showFilter"
                    v-bind:class="[ 'select-btn', 'basic-bg', (filtername === '' || typeof filtername === 'undefined' ? '' : 'active')]">
                <span>{{ buttonName }}</span>
            </button>
            <div v-show="showName" id="nameFilter" class="select-btn-box">
                <span class="close" @click.prevent="closeName">x</span>
                <label>{{ translations['Name'] }}</label>
                <div class="name-text">
                    <input type="text" data-select="name" v-model="filtername" @keyup="nameChange" autofocus>
                </div>
            </div>
        </div>
    </div>
    <div class="filter-reset-btn" @click="realResetFilter">{{translations['Reset filter']}}</div>
</template>
<script>
export default {
  name: 'Filter',
  data: function () {
    return {
      translations: window.stoffmuster.translations
    }
  },
  props: {
    showPattern: Boolean,
    showColor: Boolean,
    showWeave: Boolean,
    showMaterial: Boolean,
    showOccasion: Boolean,
    showPrice: Boolean,
    showSeason: Boolean,
    showNew: Boolean,
    showTopseller: Boolean,
    showName: Boolean,
    filtercolor: String,
    buttonColor: String,
    classcolor: String,
    filterpattern: String,
    buttonPattern: String,
    classpattern: String,
    filterweave: String,
    buttonWeave: String,
    classweave: String,
    filtermaterial: String,
    buttonMaterial: String,
    classmaterial: String,
    filteroccasion: String,
    buttonOccasion: String,
    classoccasion: String,
    buttonNew: String,
    buttonTopseller: String,
    buttonPrice: String,
    filtername: String,
    buttonName: String,
    range1: Object,
    range2: Object,
    boolfilter: Object
  },
  methods: {
    selectFabric: function (event) {
      this.$dispatch('getFabricData', event)
    },
    setFilter: function (event) {
      var t = event.currentTarget.dataset.select
      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1)
      var id = (event.currentTarget.id === 'all' ? '' : event.currentTarget.id)
      var cl = 'class' + t
      this[cl] = id.replace('100%', 'full')
      this[f] = false
      this.$dispatch('setFilter', event, function (value) {
        var b = 'button' + t.charAt(0).toUpperCase() + t.substr(1)
        this[b] = window.stoffmuster.translations[value]
      }.bind(this))
      this.$dispatch('checkDesign', event, function () {})
    },
    setBoolFilter: function (event) {
      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'))
      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1)
      if (this[f] === true) {
        this[f] = false
      } else {
        this.resetFilter()
        this[f] = true
      }
      this.$dispatch('setBoolFilter', event, function () {})
      this.$dispatch('checkDesign', event, function () {})
    },
    resetFilter: function (event) {
      this.showPattern = false
      this.showColor = false
      this.showWeave = false
      this.showMaterial = false
      this.showOccasion = false
      this.showSeason = false
      this.showPrice = false
      this.showName = false
      this.$dispatch('checkDesign', event, function () {})
    },
    realResetFilter: function () {
      this.resetFilter()
      this.$dispatch('resetFilter')
      this.resetButtons()
    },
    showFilter: function (event) {
      var t = event.currentTarget.id.substr(0, event.currentTarget.id.indexOf('Button'))
      var f = 'show' + t.charAt(0).toUpperCase() + t.substr(1)
      if (this[f] === true) {
        this[f] = false
      } else {
        this.resetFilter()
        this[f] = true
      }
      this.$dispatch('checkDesign', event, function () {})
    },
    closeName: function () {
      this.showName = false
    },
    closePrice: function () {
      this.showPrice = false
    },
    range1max: function () {
      this.range1.max = this.range2.value
      if (this.range1.value !== this.range1.min || this.range2.value !== this.range2.max) {
        this.buttonPrice = this.range1.value + ' - ' + this.range2.value + ' €'
      } else {
        this.buttonPrice = window.stoffmuster.translations['Price']
      }
    },
    range2min: function () {
      this.range2.min = this.range1.value
      if (this.range1.value !== this.range1.min || this.range2.value !== this.range2.max) {
        this.buttonPrice = this.range1.value + ' - ' + this.range2.value + ' €'
      } else {
        this.buttonPrice = window.stoffmuster.translations['Price']
      }
    },
    nameChange: function (event) {
      var t = event.currentTarget.dataset.select
      this.$dispatch('setFilter', event, function (value) {
        var b = 'button' + t.charAt(0).toUpperCase() + t.substr(1)
        if (value === '') {
          this[b] = window.stoffmuster.translations['Name']
        } else {
          this[b] = value
        }
      }.bind(this))
    },
    setPriceRange: function (event) {
      var min = parseInt(event.currentTarget.dataset.start)
      var max = parseInt(event.currentTarget.dataset.end)
      this.range1.value = min
      this.range2min()
      this.range2.value = max
      this.range1max()
      this.closePrice()
    },
    resetButtons: function () {
      this.buttonColor = window.stoffmuster.translations['Color']
      this.buttonPattern = window.stoffmuster.translations['Pattern']
      this.buttonPrice = window.stoffmuster.translations['Price']
      this.buttonWeave = window.stoffmuster.translations['Weave']
      this.buttonMaterial = window.stoffmuster.translations['Material']
      this.buttonNew = window.stoffmuster.translations['New fabrics']
      this.buttonTopseller = window.stoffmuster.translations['Topseller']
      this.buttonOccasion = window.stoffmuster.translations['Occasion']
      this.buttonName = window.stoffmuster.translations['Name']
      this.filtername = ''
      this.classpattern = ''
      this.classcolor = ''
      this.classweave = ''
      this.classmaterial = ''
      this.classoccasion = ''
    }
  },
  created: function () {
    this.resetButtons()
  }
}
</script>


// WEBPACK FOOTER //
// Filter.vue?13e3c422